export default {"src":"/_next/static/media/check-green.0ce8b22e.svg","height":20,"width":20};